export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-12 0a3 3 0 100-5.999A3 3 0 0012 12zm-3.841 2.159A2.25 2.25 0 019.75 13.5h4.5a2.25 2.25 0 012.25 2.25v2.081a.17.17 0 01-.169.169H7.67a.169.169 0 01-.169-.169V15.75c0-.597.237-1.169.659-1.591z\" fill=\"#8A8F9E\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};